'use client';

import React, { useEffect, useRef } from 'react';
import AppImage from '@/components/ui/AppImage';

const galleryItems = [
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_1455f793a-1782036404670.png",
  alt: 'Coastal living room with full-height plantation shutters, Brancaster',
  label: 'Coastal Living Room, Brancaster',
  span: 'lg:col-span-2 lg:row-span-2'
},
{
  src: "https://images.unsplash.com/photo-1652745432407-aa6b61b2a6a7",
  alt: 'Master bedroom with white plantation shutters, Holt Norfolk',
  label: 'Master Bedroom, Holt',
  span: 'lg:col-span-1'
},
{
  src: "/assets/images/WP_20170527_12_58_14_Pro-1782045961258.jpg",
  alt: 'Padget Hall shutters installation',
  label: 'Padget Hall',
  span: 'lg:col-span-1'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_1f171dedc-1782036402745.png",
  alt: 'Drawing room with elegant plantation shutters, Hunstanton',
  label: 'Drawing Room, Hunstanton',
  span: 'lg:col-span-1'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_1c59786a0-1782036402491.png",
  alt: 'Bay window with period-style plantation shutters, Norfolk cottage',
  label: 'Bay Window, Period Cottage',
  span: 'lg:col-span-1'
},
{
  src: '/assets/images/Hampton_10_year_warrenty-1782056694528.jpg',
  alt: 'Close-up detail of plantation shutter louvres and joinery craftsmanship',
  label: 'Shutter Detail & Joinery',
  span: 'lg:col-span-2'
}];


export default function GallerySection() {
  const headerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (headerRef.current) observer.observe(headerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="gallery"
      className="py-32 bg-[#E8DED1]/40"
      aria-labelledby="gallery-heading">
      
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div ref={headerRef} className="text-center mb-16 reveal-hidden">
          <p className="text-[#7B8A94] text-sm font-medium tracking-[0.25em] uppercase mb-4">
            Our Work
          </p>
          <h2
            id="gallery-heading"
            className="font-display text-[#0F1C2E] text-4xl lg:text-5xl font-medium">
            
            The Installation Archive
          </h2>
          <p className="text-[#7B8A94] text-lg mt-4 max-w-xl mx-auto leading-relaxed">
            Each project is unique. Here&apos;s a selection of recent installations.
          </p>
        </div>

        {/* Gallery grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 auto-rows-[280px] gap-4">
          {galleryItems.map((item, i) =>
          <GalleryCard key={item.label} item={item} index={i} />
          )}
        </div>
      </div>
    </section>);

}

function GalleryCard({
  item,
  index



}: {item: typeof galleryItems[0];index: number;}) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`relative overflow-hidden rounded-2xl group cursor-pointer reveal-hidden-scale ${item.span}`}
      style={{ transitionDelay: `${index * 80}ms` }}>
      
      <AppImage
        src={item.src}
        alt={item.alt}
        fill
        className="object-cover transition-transform duration-700 group-hover:scale-105"
        sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw" />
      
      {/* Hover overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#0F1C2E]/70 via-transparent to-transparent transition-opacity duration-300 opacity-0 group-hover:opacity-100" />
      {/* Hover label */}
      <div className="absolute bottom-0 left-0 right-0 p-5 transition-all duration-300 opacity-0 translate-y-4 group-hover:opacity-100 group-hover:translate-y-0">
        <p className="text-white font-medium text-sm mb-3">{item.label}</p>
        <a
          href="#contact"
          className="inline-block bg-white text-[#0F1C2E] text-xs font-semibold px-4 py-2 rounded-full hover:bg-[#E8DED1] transition-colors">
          
          Reference this style
        </a>
      </div>
    </div>);

}